import { Control, FieldErrors, FieldValues, UseFormClearErrors, UseFormWatch } from "react-hook-form";
import { IListActions } from "src/pages/Actions/Panel/interface";

export interface IComponentFCA{
    id: number;
    id2?: number;
    tablesRelated: EnumTablesRelated;
    disabled?: boolean;
    isPresentation?: boolean;
    defaultValue?: IInternalFCA[]
}

export interface IRefComponentFCA{
    executeQuery: () => Promise<void>;
}

export interface IComponentFCAItem{
    id: number;
    id2?: number;
    defaultValue: IInternalFCA;
    tablesRelated: EnumTablesRelated;
    index: number;
    delete: (idForDelete: number, indexForDelete: number) => void;
    disabled?: boolean;
    isPresentation?: boolean;
    updateFCAs: (index: number, defaultValue: IInternalFCA, editAttachments: boolean, attachmentsNumber: number) => void;
}

export interface IComponentFiveWhy{
	addResponseToCause: (val: string) => void;
	disabled?: boolean;
	fiveWhyDefaultValue: IIntba003[];
    register: (RegisterOptions?: any) => void;
    control: Control<FieldValues>;
    watch: UseFormWatch<FieldValues>;
    errors: FieldErrors<FieldValues>;
    clearErrors: UseFormClearErrors<FieldValues>;
    updateFunction:Function;
    isPresentation?: boolean;
}

export interface IIntba003{
    ina003Id: number;
    ina003Pergunta: string;
    ina003Resposta: string;
}

export enum EnumTablesRelated{
    INDICATORS = 1,
    OCCURRENCES = 2
}

export enum ICategoryIshikawa{
    MACHINE = 1,
    LABOR = 2,
    MATERIAL = 3,
    ENVIRONMENT = 4,
    METHOD = 5,
    MEASURES = 6
}

export interface IIntba005{
    ina005Id: number;
    ina005Categoria: ICategoryIshikawa;
    ina005Causa: string;
    ina005Ina005Id: number | null;
    id:string;
    parentId:string;
}

export interface IInternalFCA extends IFCA{
    id: string;
    expanded?: boolean;
}

export interface IFCA{
    ina002Id: number;
    ina002Fato: string;
    ina002Causa: string;
    intba003: IIntba003[];
    intba005: IIntba005[];
    attachmentsNumber: number;
    attachments?:File[];
    initialTab?:number;
    showAttachments?:boolean;
    actions?:IListActions[];
}
